module.exports = __webpack_public_path__ + "static/media/features-that-work-well.ce0bdba5.png";